import React from 'react';

import Icon from '../Icon/Icon';

const PairingBlueIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                <g transform='translate(-100.000000, -1471.000000)'>
                    <g transform='translate(100.000000, 1471.000000)'>
                        <g transform='translate(24.177670, 24.177670) rotate(-45.000000) translate(-24.177670, -24.177670) translate(11.677670, 11.677670)'>
                            <path
                                d='M9.35751017,11.9850202 L9.33380951,10.1167935 C9.33380951,9.68436337 9.68436337,9.33380951 10.1167935,9.33380951 L12.9877346,9.33380951 C14.2850249,9.33380951 15.3366865,10.3854711 15.3366865,11.6827614 L15.3366865,14.5537026 C15.3366865,14.9861327 14.9861327,15.3366865 14.5537026,15.3366865 L11.6827614,15.3366865 C10.3854711,15.3366865 9.33380951,14.2850249 9.33380951,12.9877346'
                                fill='#00D1D2'
                            />
                            <path
                                d='M18.0028768,10.5568872 L18.0028768,15.6546755 C18.0028768,16.9515513 16.9515513,18.0028768 15.6546755,18.0028768 L7.04460397,18.0028768 C3.15397663,18.0028768 0,14.8489002 0,10.9582728 L0,2.34820132 C0,1.05132554 1.05132554,0 2.34820132,0 L2.34820132,0 L10.9582728,0 C14.8489002,0 18.0028768,3.15397663 18.0028768,7.04460397'
                                stroke='#34303D'
                                strokeWidth='2'
                            />
                            <path
                                d='M7.06820247,14.948214 L6.9971232,9.34532452 C6.9971232,8.04844874 8.04844874,6.9971232 9.34532452,6.9971232 L17.955396,6.9971232 C21.8460234,6.9971232 25,10.1510998 25,14.0417272 L25,22.6517987 C25,23.9486745 23.9486745,25 22.6517987,25 L14.0417272,25 C10.1510998,25 6.9971232,21.8460234 6.9971232,17.955396'
                                stroke='#34303D'
                                strokeWidth='2'
                            />
                        </g>
                    </g>
                </g>
            </g>
        </Icon>
    );
};

export default PairingBlueIcon;
